// React Imports
import type { SVGAttributes } from 'react';
import React from 'react';

export const School = (props: SVGAttributes<SVGElement>) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="62" height="62" viewBox="0 0 62 62" fill="none" {...props}>
      <path
        d="M37.0158 37.957H25.5933C25.3843 37.957 25.2148 38.1265 25.2148 38.3355V40.28C25.2148 40.489 25.3843 40.6584 25.5933 40.6584H37.0158C37.2248 40.6584 37.3943 40.489 37.3943 40.28V38.3355C37.3943 38.1265 37.2248 37.957 37.0158 37.957Z"
        fill="url(#paint0_linear_9267_215621)"
      />
      <path
        d="M13.6641 36.234V47.3422C13.6641 47.7032 13.961 48.0001 14.3219 48.0001H20.7959C21.1568 48.0001 21.4538 47.7032 21.4538 47.3422V36.234C21.4538 35.8731 21.1568 35.5762 20.7959 35.5762H14.3219C13.961 35.5762 13.6641 35.8731 13.6641 36.234ZM18.275 44.4895H16.8894C16.5284 44.4895 16.2315 44.1926 16.2315 43.8316V42.446C16.2315 42.0851 16.5284 41.7881 16.8894 41.7881H18.275C18.636 41.7881 18.9329 42.0851 18.9329 42.446V43.8316C18.9329 44.1926 18.636 44.4895 18.275 44.4895ZM18.275 40.3152H16.8894C16.5284 40.3152 16.2315 40.0183 16.2315 39.6573V38.2717C16.2315 37.9108 16.5284 37.6138 16.8894 37.6138H18.275C18.636 37.6138 18.9329 37.9108 18.9329 38.2717V39.6573C18.9329 40.0183 18.636 40.3152 18.275 40.3152Z"
        fill="black"
      />
      <path
        d="M41.168 36.234V47.3422C41.168 47.7032 41.4649 48.0001 41.8258 48.0001H48.2998C48.6608 48.0001 48.9577 47.7032 48.9577 47.3422V36.234C48.9577 35.8731 48.6608 35.5762 48.2998 35.5762H41.8258C41.4649 35.5762 41.168 35.8731 41.168 36.234ZM45.7265 44.4895H44.3409C43.9799 44.4895 43.683 44.1926 43.683 43.8316V42.446C43.683 42.0851 43.9799 41.7881 44.3409 41.7881H45.7265C46.0875 41.7881 46.3844 42.0851 46.3844 42.446V43.8316C46.3844 44.1926 46.0875 44.4895 45.7265 44.4895ZM45.7265 40.3152H44.3409C43.9799 40.3152 43.683 40.0183 43.683 39.6573V38.2717C43.683 37.9108 43.9799 37.6138 44.3409 37.6138H45.7265C46.0875 37.6138 46.3844 37.9108 46.3844 38.2717V39.6573C46.3844 40.0183 46.0875 40.3152 45.7265 40.3152Z"
        fill="black"
      />
      <path
        d="M20.712 29.8223H15.1579C14.8959 29.8223 14.6572 29.962 14.5233 30.189L12.5148 33.6356C12.2295 34.1247 12.5846 34.7418 13.1493 34.7418H20.712C21.1195 34.7418 21.4456 34.4157 21.4456 34.0082V30.5616C21.4456 30.1541 21.1195 29.8281 20.712 29.8281V29.8223Z"
        fill="url(#paint1_linear_9267_215621)"
      />
      <path
        d="M41.1602 30.5597V34.0063C41.1602 34.4138 41.4862 34.7398 41.8937 34.7398H49.4564C50.0211 34.7398 50.3762 34.1227 50.091 33.6337L48.0824 30.1871C47.9485 29.96 47.7098 29.8203 47.4478 29.8203H41.8937C41.4862 29.8203 41.1602 30.1463 41.1602 30.5539V30.5597Z"
        fill="url(#paint2_linear_9267_215621)"
      />
      <path
        d="M39.5437 27.9157L31.9927 23.6482C31.5677 23.4037 31.0437 23.4037 30.6246 23.6482L23.0736 27.9157C22.6369 28.166 22.3633 28.626 22.3633 29.1325V47.3259C22.3633 47.6636 22.6369 47.9314 22.9688 47.9314H25.8972C26.2348 47.9314 26.5027 47.6578 26.5027 47.3259V42.5985C26.5027 42.1095 26.8985 41.7136 27.3876 41.7136H35.2413C35.7304 41.7136 36.1263 42.1095 36.1263 42.5985V47.3259C36.1263 47.6636 36.3999 47.9314 36.7317 47.9314H39.6601C39.992 47.9314 40.2656 47.6578 40.2656 47.3259V29.1325C40.2656 28.6318 39.9978 28.166 39.5612 27.9157H39.5437ZM28.7208 29.3071C28.9187 28.2708 29.7513 27.4325 30.7876 27.2403C32.6448 26.891 34.24 28.4862 33.8848 30.3376C33.6869 31.3739 32.8543 32.2064 31.818 32.4044C29.9667 32.7537 28.3657 31.1585 28.7208 29.3071ZM25.5944 40.654C25.3848 40.654 25.216 40.4852 25.216 40.2814V38.3369C25.216 38.1273 25.3907 37.9585 25.5944 37.9585H37.0112C37.2208 37.9585 37.3896 38.1273 37.3896 38.3369V40.2814C37.3896 40.491 37.2208 40.654 37.0112 40.654H25.5944Z"
        fill="black"
      />
      <path
        d="M31.6278 20.1246V17.1729C31.6278 17.0681 31.7151 16.9808 31.8199 16.9808H35.7555C35.9069 16.9808 36.0001 16.8178 35.9244 16.6897L35.2723 15.5894C35.2374 15.5312 35.2374 15.4555 35.2723 15.3914L35.9244 14.2911C36.0001 14.163 35.9069 14 35.7555 14H31.3076L30.9874 14.0058V20.1305C30.9874 20.2003 30.9525 20.2644 30.8884 20.2993L21.6957 25.6496C21.5385 25.7428 21.4453 25.9058 21.4453 26.0863V27.1633C21.4453 27.5534 21.8645 27.7921 22.2022 27.6L30.708 22.6513C31.0747 22.4359 31.5288 22.4359 31.8956 22.6513L40.4014 27.6C40.7391 27.7979 41.1583 27.5534 41.1583 27.1633V26.0863C41.1583 25.9058 41.0651 25.7428 40.9079 25.6496L31.7151 20.2993C31.6569 20.2644 31.6162 20.2003 31.6162 20.1305L31.6278 20.1246Z"
        fill="url(#paint3_linear_9267_215621)"
      />
      <path
        d="M33.8856 30.337C33.6877 31.3733 32.8551 32.2059 31.8188 32.4038C29.9675 32.7531 28.3665 31.1579 28.7216 29.3065C28.9195 28.2702 29.7521 27.4319 30.7884 27.2398C32.6455 26.8905 34.2408 28.4857 33.8856 30.337Z"
        fill="url(#paint4_linear_9267_215621)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_9267_215621"
          x1="25.2148"
          y1="39.3077"
          x2="37.3943"
          y2="39.3077"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F4C074" />
          <stop offset="0.34" stopColor="#E3B16A" />
          <stop offset="1" stopColor="#BE7B2B" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_9267_215621"
          x1="12.41"
          y1="32.2791"
          x2="21.4456"
          y2="32.2791"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F4C074" />
          <stop offset="0.34" stopColor="#E3B16A" />
          <stop offset="1" stopColor="#BE7B2B" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_9267_215621"
          x1="41.1602"
          y1="32.283"
          x2="50.1957"
          y2="32.283"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F4C074" />
          <stop offset="0.34" stopColor="#E3B16A" />
          <stop offset="1" stopColor="#BE7B2B" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_9267_215621"
          x1="21.4453"
          y1="20.8291"
          x2="41.1641"
          y2="20.8291"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F4C074" />
          <stop offset="0.34" stopColor="#E3B16A" />
          <stop offset="1" stopColor="#BE7B2B" />
        </linearGradient>
        <linearGradient
          id="paint4_linear_9267_215621"
          x1="28.675"
          y1="29.8247"
          x2="33.938"
          y2="29.8247"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F4C074" />
          <stop offset="0.34" stopColor="#E3B16A" />
          <stop offset="1" stopColor="#BE7B2B" />
        </linearGradient>
      </defs>
    </svg>
  );
};
